// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__oAoIT","alert":"SettungsInbox_alert__2W--m"};